function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.67,230.84c-5.24-25.63-14.44-50.65-25.38-73.65C433.43,117.51,402.53,84.56,363,65,266,17,196,37,158,76S131,182,90,211s-70,42-72,95,24,93,66,106,105,55,231,31,157-91,165-139C484,279.85,482.62,255.07,477.67,230.84Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.67,230.84c-5.24-25.63-14.44-50.65-25.38-73.65C433.43,117.51,402.53,84.56,363,65,266,17,196,37,158,76S131,182,90,211s-70,42-72,95,24,93,66,106,105,55,231,31,157-91,165-139C484,279.85,482.62,255.07,477.67,230.84Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bookshelf--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173.26,
    y: 84.52,
    width: 9.06,
    height: 40.15,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.26,
    y: 90.56,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.26,
    y: 115.47,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.21,
    y: 84.52,
    width: 12.68,
    height: 40.15,
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.93,
    y: 84.52,
    width: 9.06,
    height: 40.15,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.93,
    y: 90.56,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.93,
    y: 115.47,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.87,
    y: 84.52,
    width: 12.68,
    height: 40.15,
    style: {
      fill: "#878787",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.59,
    y: 84.52,
    width: 9.06,
    height: 40.15,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.59,
    y: 90.56,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.59,
    y: 115.47,
    width: 9.06,
    height: 3.92,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.53,
    y: 84.52,
    width: 12.68,
    height: 40.15,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.47 125.08 241.75 125.08 247.41 119.96 220.47 119.96 220.47 125.08",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245 125.34 244.32 124.17 220.03 124.12 220.73 125.34 245 125.34",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.75,
    y: 84.92,
    width: 9.06,
    height: 40.15,
    transform: "translate(-23.78 121.38) rotate(-30.04)",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.71,
    y: 92.58,
    width: 9.06,
    height: 3.92,
    transform: "translate(-19.36 116.94) rotate(-30.04)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.18,
    y: 114.14,
    width: 9.06,
    height: 3.92,
    transform: "translate(-28.47 126.08) rotate(-30.04)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.27 120.31 228.04 120.26 207.94 85.5 227.17 85.55 247.27 120.31",
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,104.75s-3.5-1.25-4.5-6.75-2.75-13.25-.75-15,5.75-2.75,6.25.75-.25,10.25.5,11.75,3.25.5,3.25-2.5c0-4.94-2-10-1.29-15,1-6.91,8-7.67,8.75,0,.42,4.24.54,8.57.54,12.83,0,1.75,3,2.75,2.75-1.5-.18-3,2-6.5,5-5.5s.5,14.25-.5,16.5S270.5,103,270.5,103v5.75L263,109l-.25-5.75A11.32,11.32,0,0,1,257.75,104.75Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.5,93.79c.09,1.25.15,2,.15,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,74.4s-1.64,1.14-1.52,4.56c.08,2.08.48,7.84.79,12.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.82,
    y1: 86.19,
    x2: 268.08,
    y2: 94.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.48,100a12.76,12.76,0,0,1-1.75.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.7,85.94a7.7,7.7,0,0,0-.89,3.55c0,2,.13,7.61-1.14,9.13a3.3,3.3,0,0,1-1.11.8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,97.19a8.09,8.09,0,0,0,2.08,4,3.68,3.68,0,0,0,4.44.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,83.66s-2.53,0-1.65,4.43c.38,1.87.73,4.17,1.18,6.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.27,
    y1: 100.52,
    x2: 264.78,
    y2: 105.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.25 106.5 276.34 113.96 275.72 119.04 275 124.95 257.01 124.95 256.29 119.04 255.67 113.96 254.76 106.5 277.25 106.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.34 113.96 275.72 119.04 256.29 119.04 255.67 113.96 276.34 113.96",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.66,
    y: 124.95,
    width: 115.47,
    height: 7.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.51,
    y: 124.95,
    width: 26.62,
    height: 7.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.92,132.63c12.37,4.56,10.14,13.18,10.14,13.18h11.71V132.63Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.87,132.63c12.36,4.56,10.13,13.18,10.13,13.18h11.72V132.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.67,132.63c12.37,4.56,10.14,13.18,10.14,13.18h11.71V132.63Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.62,132.63c12.36,4.56,10.13,13.18,10.13,13.18h11.72V132.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.48,
    y: 85.95,
    width: 103.56,
    height: 143.76,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.98,
    y: 92.19,
    width: 94.57,
    height: 131.28,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.98,
    y: 92.19,
    width: 94.57,
    height: 131.28,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.77,213.5a39,39,0,0,1-9.46,10h83.24V92.19H428.21l-2,.63c-15,4.73-30.5,18.42-39.29,43.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.46,140.48a142.23,142.23,0,0,0-5.74,36.5c-.55,14.84-3.71,25.51-7.93,33.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.3,125.51c-13.75,8-29.76,21.44-35.74,42.05-3.21,11-.2,20.92,5.75,29.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.53,201.11c8.25,9.66,20,17.26,29.51,22.37h6.51V120.66c-1.86.87-3.84,1.85-5.9,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7,126.42c7.24-14.76,8-26.47,7.17-34.23H349v60.06c3.38-4.81,7.52-11.24,12.52-19.86.31-.53.6-1,.89-1.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.66,183.27c-1.11,7.27-4.45,12.55-8.39,12.55-4.85,0-8.79-8-8.79-17.9s3.94-17.9,8.79-17.9,8.79,8,8.79,17.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.83,141.18c0,3.81-1.68,6.91-3.77,6.91s-3.76-3.1-3.76-6.91,1.68-6.91,3.76-6.91S377.83,137.36,377.83,141.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.81,170.37c3.63,1.73,6,4.75,6,8.18,0,5.37-5.9,9.73-13.19,9.73s-13.18-4.36-13.18-9.73,5.9-9.74,13.18-9.74a17.65,17.65,0,0,1,3.46.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.18,178.55c0,2.25-2.47,4.08-5.53,4.08s-5.53-1.83-5.53-4.08,2.48-4.09,5.53-4.09S424.18,176.29,424.18,178.55Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.1,153.74c0,3.12-3.09,5.65-6.91,5.65s-6.91-2.53-6.91-5.65,3.09-5.65,6.91-5.65S433.1,150.62,433.1,153.74Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.17,
    cy: 110.72,
    rx: 4.71,
    ry: 11.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.05,210.58a6.6,6.6,0,1,1-6.6-6.6A6.6,6.6,0,0,1,396.05,210.58Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.82,112.6a4.09,4.09,0,1,1-4.08-4.08A4.09,4.09,0,0,1,426.82,112.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,141.49a2.2,2.2,0,1,1-2.2-2.19A2.19,2.19,0,0,1,401.07,141.49Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.98,
    y: 92.19,
    width: 94.57,
    height: 131.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.3,
    y: 279.39,
    width: 25.69,
    height: 9.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.46 280.85 221.21 280.85 226.05 201.59 328.31 201.59 323.46 280.85",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.53 280.85 218.28 280.85 223.12 201.59 325.37 201.59 320.53 280.85",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.12 276.44 224.23 276.44 228.53 205.99 319.42 205.99 315.12 276.44",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.68 265.94 226.94 265.94 230.25 211.65 292 211.65 288.68 265.94",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3,242.62s-12.86,5.09-12.94,6.46-2.6,16.86-2.6,16.86H274l-3.22-17.84-14.15-5.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.68,239.48a6.72,6.72,0,0,0-2.63,1.37c-1,1-2.22,4.31-2.22,4.31l-.05,3.92,5.07-2.74L257,246l4.82,4.51.62-6.86s-.74-3.92-2.3-4.12S251.68,239.48,251.68,239.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.52 235.76 251.3 242.62 254.33 247.52 259.34 242.42 260.12 236.15 251.52 235.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,227.74c-.36,5.75-4.18,12.72-8.37,12.72s-7.16-7-6.81-12.72,4-10.41,8.22-10.41S264.23,222,263.88,227.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.63,228.5s-1.35-3.52-1.91-.78,2.2,5.68,2.2,5.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,227.74s3.31-1.39,2.34,1.55a5.8,5.8,0,0,1-3.36,3.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1,228.5a2.55,2.55,0,0,0-2.58-2.74,3,3,0,0,0-2.91,2.74,2.56,2.56,0,0,0,2.58,2.75A3,3,0,0,0,255.1,228.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.76,
    y1: 228.5,
    x2: 264.75,
    y2: 227.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.76,228.5a2.55,2.55,0,0,0-2.57-2.74,3,3,0,0,0-2.92,2.74,2.56,2.56,0,0,0,2.58,2.75A3,3,0,0,0,261.76,228.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.24,216.15s-3-1.56-5.25-.58-3.91,6.27-3.8,7.64a38.2,38.2,0,0,0,1.44,5.29l2.38-6.86,6.24-2.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.22,217.53s4.94-3.92,8.94-2a6,6,0,0,1,3.53,6.47c-.06,1-.14,5.48-.14,5.48l-2.38.4L262,224.19a33.84,33.84,0,0,1-3.94-1.86S252.77,221.64,253.22,217.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "255.1 228.5 254.75 234.19 256.12 234.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.03,
    y1: 236.34,
    x2: 256.97,
    y2: 236.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.33,
    y1: 247.52,
    x2: 253.24,
    y2: 265.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76,248.1s-4.09,9.22-4.21,11.18-.58,6.27-.58,6.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.36,249.08s4.07,7.06,4.6,8-.12,8.43-.12,8.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.49 254.77 274.84 248.69 277.14 246.34 279.31 242.81 280.29 242.81 279.09 246.54 282.13 244.77 284.09 241.64 285.23 242.22 282.43 249.48 277.99 251.63 277.22 254.57 273.49 254.77",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.29 265.94 277.66 253.79 273.2 253 269.68 265.94 277.29 265.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.41 270.45 226.66 270.45 226.94 265.94 288.68 265.94 288.41 270.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.18,
    y1: 267.71,
    x2: 285.83,
    y2: 267.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.22 226.14 294.44 226.14 295.32 211.83 316.1 211.83 315.22 226.14",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.22 226.14 294.44 226.14 294.59 223.79 315.37 223.79 315.22 226.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.51 218.15 303.11 214.92 302.72 221.38 308.51 218.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.87 248.29 293.09 248.29 293.96 233.99 314.74 233.99 313.87 248.29",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.87 248.29 293.09 248.29 293.24 245.94 314.01 245.94 313.87 248.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.16 240.31 301.76 237.08 301.37 243.54 307.16 240.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.51 270.45 291.74 270.45 292.61 256.14 313.39 256.14 312.51 270.45",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.51 270.45 291.74 270.45 291.88 268.1 312.66 268.1 312.51 270.45",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.8 262.46 300.41 259.23 300.01 265.69 305.8 262.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.5,
    y1: 228.5,
    x2: 314.68,
    y2: 228.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.35,
    y1: 230.86,
    x2: 314.54,
    y2: 230.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.13,
    y1: 250.85,
    x2: 313.32,
    y2: 250.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.99,
    y1: 253.2,
    x2: 313.18,
    y2: 253.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.18,289.06H269a5.71,5.71,0,0,1,5.71-5.71h3.74a5.71,5.71,0,0,1,5.71,5.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.55,
    y: 285.95,
    width: 74.22,
    height: 3.11,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.1,
    y: 285.95,
    width: 18.65,
    height: 3.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wall--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 157.13,
    y1: 136.63,
    x2: 157.13,
    y2: 77.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.13,
    y1: 432.36,
    x2: 157.13,
    y2: 142.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.07,309.8l9,121.33a1.75,1.75,0,0,0,3.49-.15L303.21,309.8Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.86,309.8l4.75,122.73a1.74,1.74,0,0,0,.92-1.55L303.21,309.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,309.8l9,121.33a1.75,1.75,0,0,0,3.49-.15L359.78,309.8Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,309.8l5.54,122.55a1.72,1.72,0,0,0,.66-1.37L359.78,309.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.52,311.12l-9,120a1.74,1.74,0,0,1-1.74,1.62h0A1.75,1.75,0,0,1,187,431l1.33-120.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,311.12l-9,120a1.74,1.74,0,0,1-1.74,1.62h0a1.75,1.75,0,0,1-1.74-1.77l1.33-120.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.46,
    y: 291.88,
    width: 234.63,
    height: 18.9,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.85,
    y: 291.88,
    width: 67.24,
    height: 18.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.46,
    y: 294.88,
    width: 234.63,
    height: 5.21,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.08,
    y: 289.17,
    width: 241.39,
    height: 6.32,
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.17,
    y: 289.17,
    width: 66.29,
    height: 6.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bubble-speech--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.29,172H262.71a6.4,6.4,0,0,0-6.4,6.4v12a6.39,6.39,0,0,0,6.4,6.4h17.06l-6.39,17.85,12.24-17.85h9.67a6.39,6.39,0,0,0,6.4-6.4v-12A6.4,6.4,0,0,0,295.29,172Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.27,
    cy: 184.8,
    r: 2.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279,
    cy: 184.8,
    r: 2.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05,184.8a2.33,2.33,0,1,0-2.32,2.33A2.32,2.32,0,0,0,290.05,184.8Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 433,
    x2: 477,
    y2: 433,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 433,
    x2: 436,
    y2: 433,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.64,256.28c-2.93-5-11.55-24.25-11.55-24.25a39.52,39.52,0,0,1,1.26-6.08c.71-2,2.5-8.06,2.14-9.32s-5.55-3.58-6.08-3.76.71-3.22-1.26-3.94-2.68.36-2.68.36l-.75,5-2.3,3.6a29.12,29.12,0,0,0-3-2c-1.61-.9-5.37-1.26-5.55.18s3,2.68,4.11,3.58,2.51,5.19,3.77,6.45a46,46,0,0,1,3.22,3.93l.72,2.33s2.45,23.59,2.74,29.46,1.17,21.4,2.93,23.74,2.06,3.82,7,2.06,5.86-4.11,7-9.39S185.57,261.26,182.64,256.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4,278.26c1.17-5.27,1.17-17-1.76-22-.32-.55-.71-1.26-1.15-2.1-6.63-1.93-12.93,1.22-12.93,1.22l-1.6.7c.21,2.45.37,4.5.43,5.75.3,5.86,1.17,21.4,2.93,23.74s2.06,3.82,7,2.06S183.22,283.54,184.4,278.26Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.26,177a34.54,34.54,0,0,1,1.2,8.13c0,3.91-1.2,6.32.61,7.52s3.31,1.21,3,3.62a6.47,6.47,0,0,1-1.51,3.61s-.6,12.34-1.2,13.55-8.43-.3-10.24-.61-6.92,2.11-10.24-4.51-.6-16.56,5.42-21.68A147.35,147.35,0,0,1,161.26,177Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.46,185.08s-1.63-1.22-2.49.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,190.06a7.34,7.34,0,0,0,.22,3.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,204.2a2,2,0,0,1-2.57-1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.41,260.8s-1,4.58-1.89,7-16.85,6.86-23.8,7.78a118.48,118.48,0,0,1-13.8.91l.44,12.66s13.46.27,14.41,0,23.61-10.4,23.61-10.4l9.78-1.28s4.11-1,4.27-4.19-3.47-12.26-5.12-13.67-5.13-5.15-7.22-2.85S167.41,260.8,167.41,260.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.4,283.53c0-5.47,1.4-5.61,3-7.78a120.23,120.23,0,0,1-12.45.74l-.33,11.62s7.37.68,11.86,1C139.11,289.68,137.4,287.05,137.4,283.53Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.86,308.13A46.9,46.9,0,0,0,161.2,295l-17.56,7.49a40.14,40.14,0,0,0-5.38-9.36l-3.28-4,2.11-11.47s12.64-8.66,14.27-12.41l.06-.12c2.54,3.93,13.56,20.94,15.63,22.59,2.34,1.88,9.36,2.11,12.4-.7s4.45-4.68,3.75-8.89c0,0-4.68-10.07-7.26-14.52s-8.19-20.36-11-25.28c-2-3.52-2.83-6-4.25-7.66a27.77,27.77,0,0,0-3.47-4.74c-2.81-3-10.54-3.75-12.18-4.45s-1.87-.94-11.23-3.74-19.9-4.45-27.39,1.4c0,0-10.06,11.94-14,31.6s-4.22,39.56-4.68,43.07-4.45,20.6-5.62,30.43S91.21,343.94,97.53,347s33.47,3.51,49.39,0,41.2-19.43,41.2-19.43S189.05,317.73,180.86,308.13Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.47,
    y1: 264.88,
    x2: 136.26,
    y2: 264.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26,259.77a96.37,96.37,0,0,1,13.1,5.52l-8.24-.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.75,265.68a10.94,10.94,0,0,1,1.66,4.81c0,2.21.37,5.17-.55,4.25s-1.3-4.07-1.3-4.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.21,263.1s3.46-1.88,5,.38,1.13,6.77,0,9-2.42.1-2.26-1.88S176.21,263.1,176.21,263.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.91,260.7s3.47-1.88,5,.38,1.12,6.76,0,9-2.42.1-2.26-1.88S174.91,260.7,174.91,260.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,258.11s3.47-1.88,5,.38,1.13,6.77,0,9-2.42.1-2.26-1.88S173.32,258.11,173.32,258.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.54,167.61a19.7,19.7,0,0,1-2.68,10.24c-5.12,7.83-9.93,6.92-12,13.25S144.7,204,148,207.66s6,1.5,6,1.5,2.11,5.42-3.31,10.84-14.75,3.31-17.16,2.41a16,16,0,0,1-4.21-2.41s-1.51,4.22-9,4.22-16-5.12-16-14.46,5.11-15.65,6.32-19.27-2.11-14.75,3-21.67,13-12,19-12,17.71,3.29,17.76,3.31c.79.43,5.85-1.63,7.22-1.54C162.65,158.87,164.48,163,164.54,167.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,210.44a12.45,12.45,0,0,0,3.29,0",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,172.86a21.14,21.14,0,0,1-2.91,7.55c-4.68,7.35-10,10-16.37,17-4.09,4.53-3.32,9.05,0,11.42",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,165.05a19,19,0,0,1,.29,3.34",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,172.06s-1,10.35-5.34,16.36-13,9-12.69,15.36",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.3,345.31s6.24,32.06,11.58,47.64,10.68,29.83,12,31.17,4.9,6.23,4.9,6.23a10.29,10.29,0,0,1-5.79,2.23c-3.12,0-7.12-4-10.69-6.24s-4-3.56-11.13-6.23-1.33-9.79.45-13.36a15.37,15.37,0,0,0,1.78-6.23,70.52,70.52,0,0,0-14.69-27.16C171.6,360.9,169.37,332,169.37,332l21.37-8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,422.52l-1.29.26s-7.57-10.24-13.35-13.8a12.59,12.59,0,0,0-6.68-2.22c-1.79,3.56-7.57,10.68-.45,13.35s7.57,4,11.13,6.23,7.57,6.24,10.69,6.24a10.29,10.29,0,0,0,5.79-2.23s-3.57-4.9-4.9-6.23A7.44,7.44,0,0,1,217,422.52Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.41,431.31c-3.52-2.43-6.7-7.83-12.43-11.2-5.21-3.06-7.89-3.18-9-2.95a4.84,4.84,0,0,0,3.26,2.95c7.13,2.67,7.57,4,11.13,6.23C208.62,427.78,211.1,430,213.41,431.31Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,432.58a5.23,5.23,0,0,1-.68-.07A4,4,0,0,0,217,432.58Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.62,297s21.4-7.58,23.4-2.58,11.16,23.65,7.82,31.31-26.82-22-30.16-22.64S154.23,299.24,154.62,297Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.59,306.77s24.33-2,29,2.34-11.33,56.33-20,72.66C171,407.31,175.11,414,175.11,414s1,4,7.67,10.34,8.67,7.33,6.33,8.33-12.33,0-13.33-.67-8.33-6.66-15-8.66-5.67-3.34-2.67-9.34,2.67-1,6-11.33a305.42,305.42,0,0,0,9.44-38.85c1.77-10.71,4.47-22.47,3.71-33.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.41,323.05a32.32,32.32,0,0,0-12.55-14.92C170.22,301.34,161.2,295,161.2,295l-17.56,7.49s4.28,7.26-17.72,10.93c-16.94,2.82-32.49-1.27-40.88-6.2-1.17,5.81-2.39,12.27-3,17-1.17,9.83,9.13,19.66,15.45,22.71s57.24,9.36,70.95.55C193.41,331.51,193.41,323.05,193.41,323.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.65,308c-2.35,1.93-6.93,4-15.73,5.43-16.94,2.82-32.49-1.27-40.88-6.2-.3,1.49-.6,3-.9,4.55,5.75,3.46,17.83,9.32,31.45,7.65C131.84,317.44,139.06,313,141.65,308Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.67,329.42c-.78,1-1.59,2-2.41,3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.92,310.44a152.22,152.22,0,0,1-10.28,16.34",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.59,316.77s-6,8-12.33,12.67",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.78,424.32C176.11,418,175.11,414,175.11,414a2.17,2.17,0,0,1-.52-.74c-.45.47-1.81,1.36-5.14.08-2.89-1.11-5.63-3-8.52-4.27-.69,1.23-1.36,2-2.82,4.93-3,6-4,7.34,2.67,9.34s14,8,15,8.66,11,1.67,13.33.67S189.45,430.65,182.78,424.32Z",
    style: {
      fill: "#000000",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.92,
    y1: 326.44,
    x2: 200.26,
    y2: 319.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.45,263.06s36.12-4.52,59.2,2l3.51,87.81H62S65.49,305.7,53.45,263.06Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.65,265.06c-23.08-6.52-59.2-2-59.2-2a243.35,243.35,0,0,1,7.67,43.42,216.54,216.54,0,0,1,54.75,39Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76,435a2,2,0,0,1-1.88-1.3c-8-21.56-10-77.53-10.12-79.9a2,2,0,0,1,4-.14c0,.58,2.08,57.69,9.87,78.64a2,2,0,0,1-1.18,2.57A1.84,1.84,0,0,1,180.76,435Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.21,435a2,2,0,0,1-1.87-1.3c-8-21.56-10-77.53-10.13-79.9a2,2,0,1,1,4-.14c0,.58,2.08,57.69,9.88,78.64a2,2,0,0,1-1.18,2.57A1.89,1.89,0,0,1,137.21,435Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.22,352.83H61.05v-4H176.24a4,4,0,0,1,4,4Z",
    style: {
      fill: "#919191",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.05,
    y: 351.86,
    width: 119.16,
    height: 3.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.76,435a2,2,0,0,1-2-2.41c11.31-53.58,1-166.25.86-167.38a2,2,0,1,1,4-.37c.11,1.14,10.5,114.4-.93,168.57A2,2,0,0,1,111.76,435Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76,433.54a1.79,1.79,0,0,1-.55-.08A2,2,0,0,1,47.83,431c26-92.3,3.93-166.62,3.71-167.36a2,2,0,0,1,3.82-1.17c.23.75,22.68,76.13-3.68,169.61A2,2,0,0,1,49.76,433.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.38,268.65s-12.29-6.83-13.2,8.65S399,393.39,399,393.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,278.66s10,22.31,5.47,113.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.65,271.77s-4.71,3-7.38-.44,1.81-9.76-2.14-12.46-10.78,1.42-10.78,1.42,5.25,1.54,5.08,4.41-2.7,3.95-3,2.7-2.85-7.57-7.11-4.94a10.55,10.55,0,0,0-4.92,6.7s9.93-1.06,10.53,2.67-4.07-.65-8.17-.89-7.84.36-7.57,2.84a32.62,32.62,0,0,1-.39,6.56,12.23,12.23,0,0,1,8-2.82c4.51.27,4.34,3.14.24,2.9s-7.62,3.66-7.62,3.66,3.74,6.39,8.49,9.55,6.46,2,7-.41-.72-8.68,2.15-8.51-4.75,10.82-1.09,11.45,6.61-.43,7.57-2.84l1-2.41s-1.28-6.25-.72-8.68,1.23.07,1.88,3,1.06,9.93,2.31,9.59,5.26-5.44,6.2-7.45-5.28-8.12-5.21-9.35,4.87,1.11,5.62,2.39a30.3,30.3,0,0,1,1.47,3s3-1.88,2.92-7.64S405.65,271.77,405.65,271.77Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.65,271.77s-4.71,3-7.38-.44,1.81-9.76-2.14-12.46-10.78,1.42-10.78,1.42,5.25,1.54,5.08,4.41-2.7,3.95-3,2.7-2.85-7.57-7.11-4.94a10.55,10.55,0,0,0-4.92,6.7s9.93-1.06,10.53,2.67-4.07-.65-8.17-.89-7.84.36-7.57,2.84a32.62,32.62,0,0,1-.39,6.56,12.23,12.23,0,0,1,8-2.82c4.51.27,4.34,3.14.24,2.9s-7.62,3.66-7.62,3.66,3.74,6.39,8.49,9.55,6.46,2,7-.41-.72-8.68,2.15-8.51-4.75,10.82-1.09,11.45,6.61-.43,7.57-2.84l1-2.41s-1.28-6.25-.72-8.68,1.23.07,1.88,3,1.06,9.93,2.31,9.59,5.26-5.44,6.2-7.45-5.28-8.12-5.21-9.35,4.87,1.11,5.62,2.39a30.3,30.3,0,0,1,1.47,3s3-1.88,2.92-7.64S405.65,271.77,405.65,271.77Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.81,285.28c3.07-3.79,7.58-8.92,11.37-11.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.26,289.89s.78-1.09,2.06-2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.18,274.85s4.56,6.44,5.4,13.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,278.66s1.28-.75.8,7.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,271s2.61-2.31,1.23-6.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.83,
    y1: 274.95,
    x2: 387.97,
    y2: 271.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.92,278.42s-5.9-4.46-9.59-4.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,259.62s-.19,6.76-5.47,7.09-8.54-8.47-13.94-6.35-5.92,11.76-5.92,11.76,5.12-4.21,7.88-2.09,2.12,5.4.63,4.88-9.51-2.31-9.79,3.75a12.82,12.82,0,0,0,3.35,9.5s5.71-10.67,9.87-8.73-3.43,3.64-6.47,7.58-5,8.09-2.31,9.52a39.13,39.13,0,0,1,6.3,4.85s-.72-5.58,2.62-9.91,6.09-2.21,3.06,1.73-1.53,10.13-1.53,10.13,8.94.61,15.34-2,6.44-5.09,4.38-7.3-9.18-5.19-7.06-8,7.6,12.13,10.73,8.89,4.07-6.91,2.31-9.52l-1.76-2.6s-7.12-3-9.18-5.2.91-1.18,4.28.16,10.66,5.71,11.18,4.22-1.87-9-3.23-11.28-11.74-.25-12.92-1.16,4.43-4.12,6.22-4a37.53,37.53,0,0,1,4,.55s.16-4.28-5.66-8.13S422.41,259.62,422.41,259.62Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.41,259.62s-.19,6.76-5.47,7.09-8.54-8.47-13.94-6.35-5.92,11.76-5.92,11.76,5.12-4.21,7.88-2.09,2.12,5.4.63,4.88-9.51-2.31-9.79,3.75a12.82,12.82,0,0,0,3.35,9.5s5.71-10.67,9.87-8.73-3.43,3.64-6.47,7.58-5,8.09-2.31,9.52a39.13,39.13,0,0,1,6.3,4.85s-.72-5.58,2.62-9.91,6.09-2.21,3.06,1.73-1.53,10.13-1.53,10.13,8.94.61,15.34-2,6.44-5.09,4.38-7.3-9.18-5.19-7.06-8,7.6,12.13,10.73,8.89,4.07-6.91,2.31-9.52l-1.76-2.6s-7.12-3-9.18-5.2.91-1.18,4.28.16,10.66,5.71,11.18,4.22-1.87-9-3.23-11.28-11.74-.25-12.92-1.16,4.43-4.12,6.22-4a37.53,37.53,0,0,1,4,.55s.16-4.28-5.66-8.13S422.41,259.62,422.41,259.62Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,292.69C418,287,415.92,279,416.06,273.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.88,299.4s-.56-1.54-1.33-3.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.36,272.2s9.55-.18,16.76,3.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.66,280s.12-1.79,8,4.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.3,271.43s-.54-4.18-6.09-5.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 414.81,
    y1: 277.62,
    x2: 410.14,
    y2: 277.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62,283.9s-8.49,2.87-11.22,6.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.76,304.62s26.86,17.75,26.41,86.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.88,299.93s-.86,7.78-7,7.66-9-10.58-15.48-8.64-7.95,13-7.95,13,6.32-4.38,9.3-1.66,1.93,6.43.26,5.69-10.76-3.57-11.65,3.4a14.8,14.8,0,0,0,3,11.27s7.6-11.77,12.21-9.13-4.3,3.87-8.18,8.13-6.51,8.86-3.57,10.76a45.19,45.19,0,0,1,6.82,6.2s-.31-6.5,3.95-11.19,7.25-2,3.37,2.29-2.72,11.54-2.72,11.54,10.27,1.55,17.9-.85,7.9-5.26,5.73-8-10.1-6.86-7.39-9.84,7.62,14.72,11.54,11.27,5.34-7.58,3.56-10.76l-1.78-3.18s-7.93-4.11-10.1-6.86,1.16-1.27,4.92.59,11.77,7.59,12.5,5.93-1.31-10.54-2.66-13.33-13.52-1.4-14.8-2.56,5.51-4.33,7.56-4a44.47,44.47,0,0,1,4.53,1s.58-4.92-5.77-9.92S398.88,299.93,398.88,299.93Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.88,299.93s-.86,7.78-7,7.66-9-10.58-15.48-8.64-7.95,13-7.95,13,6.32-4.38,9.3-1.66,1.93,6.43.26,5.69-10.76-3.57-11.65,3.4a14.8,14.8,0,0,0,3,11.27s7.6-11.77,12.21-9.13-4.3,3.87-8.18,8.13-6.51,8.86-3.57,10.76a45.19,45.19,0,0,1,6.82,6.2s-.31-6.5,3.95-11.19,7.25-2,3.37,2.29-2.72,11.54-2.72,11.54,10.27,1.55,17.9-.85,7.9-5.26,5.73-8-10.1-6.86-7.39-9.84,7.62,14.72,11.54,11.27,5.34-7.58,3.56-10.76l-1.78-3.18s-7.93-4.11-10.1-6.86,1.16-1.27,4.92.59,11.77,7.59,12.5,5.93-1.31-10.54-2.66-13.33-13.52-1.4-14.8-2.56,5.51-4.33,7.56-4a44.47,44.47,0,0,1,4.53,1s.58-4.92-5.77-9.92S398.88,299.93,398.88,299.93Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.62,337.83c-1.44-6.68-3.05-16.13-2.39-22.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.52,345.78s-.5-1.83-1.17-4.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,314.06s11,.7,19,5.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.63,323s.31-2.05,8.83,5.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.25,312.7s-.23-4.88-6.46-7.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 388.41,
    y1: 319.98,
    x2: 383.07,
    y2: 319.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.76,327.3s-10.07,2.52-13.56,6.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.23,358.79s17.3,13.2,19.12,32.78L391.71,326",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.11,349.23c-22.76-4.1-22.76,42.34-22.76,42.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,391.12s-13.2-96.06,25-96.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.44,346.47c-3.11-3.5-9.72-3.5-13.6,5.44s-.39,7.39-.39,7.39,7.38-2.34,12.05-3.89,10.88-5.44,11.27-3.11-3.11,4.66-7.39,5.44S395.84,361.63,397,364s3.89,9.33,3.89,9.33a97.78,97.78,0,0,1,10.49-7.77c5.06-3.11,8.17-1.95,5.45,1.55s-10.5,7.38-8.94,12.05,10.88,10.49,10.88,10.49,1.17-9.71,3.89-12.82,2.72.39,1.94,5.83a63.08,63.08,0,0,0-.78,7l10.88,3.89a77.69,77.69,0,0,1,5.83-7.77l2-2s-8.55-7.38-8.94-12,5.83,0,7.77.78,5.05,6.22,5.05,6.22,1.95-8.94,2.34-12.05l.39-3.11s-8.17-3.11-11.28-3.11-4.66,2.33-4.66-.77,3.11-5.06,6.61-4.67a60.88,60.88,0,0,1,9.33,2.33s2.33-1.94,1.55-7.77-2.72-5.83-7.38-4.28-7.78,5.06-11.28,5.06-1.55-4.28.78-5.44,8.16-3.5,9.33-3.89-6.22-5.83-10.11-6.61-8.92,2-8.55,5.83C424.21,348.41,412.55,350,409.44,346.47Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,386.49q.18,1.75.24,3.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.65,358.59A102.94,102.94,0,0,1,434,382.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.25,355.47c-1.92-4.14-3.37-6.67-3.37-6.67a11.44,11.44,0,0,0,5.05-4.66,13,13,0,0,1,3.89-4.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.28,362s14-5.83,14-4.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,354.63s6.22-3.11,11.66-3.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.71,364a53.71,53.71,0,0,0-7.39,7.39,33.64,33.64,0,0,0-5.44,8.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,365.52s8.17-2.34,12.44,1.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.77,313c-4.23-2.5-8.91-2.56-11.21-5.2s2.21-4,4.62-3,8,3.87,9.05,4.49.33-8.51-1.63-12-7.33-5.45-10-2.63c-5.65,5.93-14.47-1.85-13.87-6.49s-3.73-9.63-13-6.71-5.83,4.55-5.83,4.55,6.6,4.05,10.84,6.55,11.24,4.65,9.73,6.47-5.56.71-8.95-2-13.12-9.19-14.12-6.78-4.5,9.05-4.5,9.05a98.52,98.52,0,0,1,12.75,2.83c5.66,1.78,6.82,4.89,2.4,5.13s-12.46-3.08-15,1.15-.79,15.09-.79,15.09,8.1-5.48,12.23-5.47,1.49,2.31-3.13,5.29a62.34,62.34,0,0,0-5.79,4l4.2,10.77a77.81,77.81,0,0,1,9.69-.7l2.74.2s0-11.3,3.24-14.65,3.82,4.4,4.51,6.38-1.38,7.89-1.38,7.89,8-4.39,10.62-6.14l2.61-1.74s-3-8.21-5.05-10.55-4.81-2-2.47-4,5.86-1,7.86,1.94a60.09,60.09,0,0,1,4.35,8.57s3,.49,6.89-3.92S451,315.5,446.77,313ZM410,325.44c-3.11-1.56,4.27-4.67,4.27-4.67C417,320.39,413.1,327,410,325.44Zm5.23-14.51c-1.32-.66,2.65-2,2.65-2C423.62,310,416.55,311.59,415.22,310.93Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.9,333.36c-.8.85-1.64,1.68-2.49,2.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.85,309.17a102.6,102.6,0,0,1-13.39,21.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.29,306.07c1.87-4.17,2.82-6.92,2.82-6.92a11.54,11.54,0,0,0,6.84.76,12.93,12.93,0,0,1,6.07-.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.91,305.05c.88-.77-12.69-7.51-12.69-7.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.06,309.13s6.43,2.66,10,6.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.49,313.49a53.85,53.85,0,0,0-10.42-.74,33.8,33.8,0,0,0-10.32,1.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,317.74s7.11,4.63,7,10.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.37,366.85c-3.4-2-7.17-2.05-9-4.18s1.77-3.2,3.71-2.4,6.44,3.12,7.29,3.62.26-6.86-1.32-9.63-5.9-4.38-8.05-2.12c-4.55,4.78-11.65-1.49-11.16-5.22s-3-7.75-10.49-5.4-4.69,3.66-4.69,3.66,5.31,3.26,8.72,5.27,9.05,3.75,7.83,5.21-4.47.58-7.2-1.61-10.56-7.4-11.36-5.46-3.62,7.28-3.62,7.28a80.17,80.17,0,0,1,10.26,2.28c4.55,1.43,5.48,3.93,1.92,4.12s-10-2.48-12,.93-.64,12.15-.64,12.15,6.52-4.42,9.84-4.41,1.2,1.86-2.51,4.26a50.13,50.13,0,0,0-4.66,3.22l3.37,8.66a62.06,62.06,0,0,1,7.8-.55l2.21.15s0-9.09,2.61-11.79,3.07,3.54,3.62,5.14-1.11,6.35-1.11,6.35,6.46-3.54,8.55-4.94l2.1-1.41s-2.42-6.6-4.06-8.49-3.88-1.6-2-3.24,4.71-.78,6.32,1.55a49,49,0,0,1,3.51,6.9s2.41.39,5.54-3.15S389.78,368.87,386.37,366.85Zm-29.6,10c-2.5-1.25,3.44-3.75,3.44-3.75C362.4,372.8,359.27,378.12,356.77,376.86ZM361,365.19c-1.07-.54,2.13-1.6,2.13-1.6C367.74,364.48,362.05,365.72,361,365.19Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.71,383.24c-.65.68-1.32,1.35-2,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.54,363.77a82.49,82.49,0,0,1-10.77,17.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.7,361.27c1.5-3.35,2.27-5.56,2.27-5.56a9.3,9.3,0,0,0,5.5.61,10.34,10.34,0,0,1,4.88-.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,354.41s10.93,5.43,10.22,6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,363.74s5.17,2.14,8,5.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.83,367.25a43.16,43.16,0,0,0-8.38-.59,26.63,26.63,0,0,0-8.3,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,370.67s5.72,3.73,5.61,8.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.49,302.67s-4.28,3.11-7,0,1.17-9.33-2.72-11.66-10.1,1.94-10.1,1.94,5.05,1.17,5.05,3.89-2.33,3.89-2.72,2.72-3.11-7-7-4.27a10,10,0,0,0-4.27,6.6s9.32-1.55,10.1,1.95-3.88-.39-7.77-.39-7.39.78-7,3.11a30.54,30.54,0,0,1,0,6.22,11.56,11.56,0,0,1,7.39-3.11c4.27,0,4.27,2.72.39,2.72s-7,3.89-7,3.89,3.89,5.83,8.55,8.55,6.22,1.55,6.61-.78-1.17-8.16,1.55-8.16-3.88,10.49-.39,10.88,6.22-.78,7-3.11l.78-2.33s-1.56-5.83-1.17-8.16,1.17,0,1.94,2.72,1.56,9.32,2.73,8.94,4.66-5.45,5.44-7.39-5.44-7.38-5.44-8.55,4.66.78,5.44,1.94,1.55,2.72,1.55,2.72,2.72-1.94,2.33-7.38S372.49,302.67,372.49,302.67Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.71,316.77c2.69-3.75,6.68-8.85,10.12-11.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.61,321.33s.69-1.08,1.8-2.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.77,306.17s4.67,5.83,5.83,12.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.11,310.06s1.16-.78,1.16,7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,302.67s2.33-2.33.78-6.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.72,
    y1: 306.56,
    x2: 355.78,
    y2: 303.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.22,310.06s-5.83-3.89-9.33-3.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.69,
    y: 389.75,
    width: 30.05,
    height: 43.25,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideTwo);
export default __webpack_public_path__ + "static/media/slideTwo.61f10496dc3e5e5045a863a01073e72c.svg";
export { ForwardRef as ReactComponent };